import { FC, useMemo } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Table } from '../../../components';
import { MobileMaterialsProvided } from './MobileMaterialsProvided';
import { IMaterialsProvided } from '../../../models';

interface IMaterialsProvidedProps {
  materialsProvided: IMaterialsProvided[];
  checklistLoading: boolean;
}

export const MaterialsProvided: FC<IMaterialsProvidedProps> = ({
  materialsProvided,
  checklistLoading
}) => {
  const isMobile = useMediaQuery('(max-width: 960px)');
  const columns = useMemo(() => {
    return [
      {
        Header: 'Description',
        accessor: 'description',
        sort: false
      },
      {
        Header: 'Manufacturer',
        accessor: 'manufacturer',
        sort: false
      },
      {
        Header: 'Model',
        accessor: 'model',
        sort: false
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Materials Provided
      </Typography>
      <Table
        columns={columns}
        data={materialsProvided}
        isLoading={checklistLoading}
        ResponsiveComponent={isMobile ? MobileMaterialsProvided : undefined}
        hidePagination
      />
    </Box>
  );
};
